import { useContent } from "contexts/contentContext/contentContext";

interface InboxOutboxLabelI {
  isOutbox: boolean;
  isJForm: boolean;
}

const InboxOutboxLabel = (props: InboxOutboxLabelI) => {
  const { isOutbox, isJForm } = props;
  const { getTextByKey } = useContent();

  return (
    <div className="inbox-outbox-label">
      {getTextByKey(!isOutbox || isJForm ? "inbox-label" : "outbox-label")}
    </div>
  );
};

export default InboxOutboxLabel;
